var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-header-dropdown',{staticClass:"app_header_dropdown",attrs:{"heading":_vm.$t('language.language'),"items":_vm.items,"use-colored-flags":_vm.useColoredFlags}})
}
var staticRenderFns = []

export { render, staticRenderFns }